import { ErrorState } from '../types';

class Validator {
  static validateEmail(email: string): ErrorState {
    if (email === '') {
      return {
        isError: true,
        message: 'Input is empty',
      };
    }

    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email,
      )
    ) {
      return {
        isError: true,
        message: 'Not a email',
      };
    }

    return {
      isError: false,
      message: '',
    };
  }

  static validatePassword(password: string): ErrorState {
    if (password === '') {
      return {
        isError: true,
        message: 'Password is empty',
      };
    }
    if (password.length < 8) {
      return {
        isError: true,
        message: 'Password length at least 8',
      };
    }

    return {
      isError: false,
      message: '',
    };
  }
}

export default Validator;
